import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';

export const DEFAULT_AUDIENCE_ITEMS = [
  { label: 'Deals', to: '/local-deals-near-me', audience: 'patron' },
  { label: 'For Businesses', to: '/for-businesses', audience: 'business' },
  { label: 'For Venues', to: '/for-venues', audience: 'venue' },
  { label: 'Pricing', to: '/pricing' },
];

const ACTIVE = {
  patron: 'bg-audience-patron-strong text-white',
  business: 'bg-audience-business-strong text-white',
  venue: 'bg-audience-venue-strong text-white',
  none: 'bg-navy text-white',
};

const IDLE = {
  patron: 'text-navy hover:bg-audience-patron-soft',
  business: 'text-navy hover:bg-audience-business-soft',
  venue: 'text-navy hover:bg-audience-venue-soft',
  none: 'text-navy hover:bg-navy/5',
};

/**
 * The three-audience front door: Deals · For Businesses · For Venues · Pricing.
 * NavLink sets aria-current="page" on the active item. Mobile: one row of pills
 * that scrolls horizontally; desktop: inline.
 *
 * Props: items ([{ label, to, audience?, end? }], defaults above), label (nav
 * aria-label, default 'Audiences'), className.
 */
export default function AudienceNav({ items = DEFAULT_AUDIENCE_ITEMS, label = 'Audiences', className }) {
  return (
    <nav aria-label={label} className={cn('w-full', className)}>
      <ul className="-mx-4 flex snap-x gap-2 overflow-x-auto px-4 pb-1 md:mx-0 md:flex-wrap md:overflow-visible md:px-0 md:pb-0">
        {items.map((item) => {
          const a = ['patron', 'business', 'venue'].includes(item.audience) ? item.audience : 'none';
          return (
            <li key={item.to} className="shrink-0 snap-start">
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  cn(
                    'inline-flex min-h-11 items-center whitespace-nowrap rounded-full px-4 font-body text-sm font-semibold transition-colors',
                    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2',
                    isActive ? ACTIVE[a] : IDLE[a],
                  )
                }
              >
                {item.label}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
